import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider } from '@material-ui/core'
import { bomItemExternalUrlSelector } from 'features/BillOfMaterials/store/selectors/bomItemExternalUrlSelector'
import { useAppSelector } from 'store/configureStore'
import { BomItemMenuItem } from './BomItemMenuItem'

export const OpenOnErpMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose: () => void
}) => {
  const externalUrl = useAppSelector(bomItemExternalUrlSelector(bomItemId))

  if (!externalUrl) {
    return null
  }

  return (
    <span>
      <BomItemMenuItem
        onClick={() => window.open(externalUrl)}
        primaryTextTranslationKey="project:open-on-erp"
        secondary={<>{externalUrl}</>}
        icon={<FontAwesomeIcon icon={faExternalLinkAlt as IconProp} size="lg" />}
        closeOnClick
        onClose={onClose}
        hiddenForBuyers
      />
      <Divider />
    </span>
  )
}
